import React, { useState, useEffect } from "react";
import { Card, CardBody, Button, ButtonToolbar, Row, Col } from "reactstrap";
import Modal from "../../../shared/components/Modal";
import { Field, reduxForm } from "redux-form";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Input from "@material-ui/core/Input";
import { makeStyles } from "@material-ui/core/styles";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import clsx from "clsx";
import DataCups from "./DataCups";
import ReactTableActions from "./ReactTableActios";
import Spinner from "react-bootstrap/Spinner";
import Tooltip from "@material-ui/core/Tooltip";
import AddBoxIcon from "@material-ui/icons/AddBox";
import IconButton from "@material-ui/core/IconButton";
import ModalMat from "@material-ui/core/Modal";
import CupsDataActions from "./CupsDataActions";
import ServicesTables from "./ServicesTables";
import TypesServices from "./TypesServices";
import { FormControlLabel, FormLabel } from "@material-ui/core";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    marginTop: theme.spacing(3),
  },
}));

const ServicesForm = ({}) => {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const classes = useStyles();

  const [modalCups, setModalCups] = useState(false);
  const [modalTypesServices, setModalTypesServices] = useState(false);
  const [listTypesServices, setListTypesServices] = useState([]);
  const [save, setSave] = useState(false);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(true);
  const [cups, setCups] = useState([]);
  const [labs, setLabs] = useState([]);
  const [data, setData] = useState([]);
  const [cupCode, setCupCode] = useState("");
  const [idCup, setIdCup] = useState("");
  const [serveName, setServName] = useState("");
  const [serveTipo, setServTipo] = useState("");
  const [idServe, setIdServ] = useState(0);
  const [idEsp, setIdEsp] = useState(0);
  const [formato, setFormato] = useState(0);
  const [speciallity, setSpeciallity] = useState([]);
  const [porcentaje, setPorcentaje] = useState(0);
  const [codigo, setCodigo] = useState(null);
  const [ripConcept, setRipConcept] = useState(null);
  const [requireMultipleAppointments, setRequireMultipleAppointments] =
    useState(false);
  const [idHospitalizacion, setIdHospitalizacion] = useState(false);
  const [limitMultipleAppointments, setLimitMultipleAppointments] =
    useState(null);
  const [listRipConcept, setListRipConcept] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [idDelete, setIdDelete] = useState(0);
  const [openAlert, setOpenAlert] = useState(false);
  const [modalAlert, setModalAlert] = useState({
    message: "",
    color: "",
    title: "",
  });
  const [abreviatture, setAbreviatture] = useState("");
  const [typeLedgerAccounts, setTypeLedgerAccounts] = useState([]);
  const [selectedLedgerAccount, setSelectedLedgerAccount] = useState(null);
  const [duration, setDuration] = useState("");
  const [listConsentimientoInformado, setlistConsentimientoInformado] =
    useState(null);
  const [consentimiento, setConsentimiento] = useState([]);
  const [idClinica] = useState(sessionStorage.getItem("id_clinica"));

  useEffect(() => {
    loadServices();
    loadSpeciallities();
    listRipsConcepts();
    getTypesServices();
    getListAccountingAccount();
    getConsentimientoInformado(idClinica);
  }, []);

  const getListAccountingAccount = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "cajas-contables/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          return response.json();
        } else {
          throw new Error("Data");
        }
      })
      .then((response) => {
        setTypeLedgerAccounts(response);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getConsentimientoInformado = async (id) => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        "historia-plantillas/consultar?id_clinica=" +
        id,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setlistConsentimientoInformado(
          data.plantilla.consentimiento_informado.consentimiento_informado
        );
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    //autoIncrement()
  };

  const loadServices = () => {
    setLoad(true);
    setOpenAlert(false);
    fetch(process.env.REACT_APP_PUBLIC_URL + "servicio/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        filterData(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  /*   const autoIncrement = () => {
    let lastOneArray = data.plantilla.consentimiento_informado.at(-1);
    console.log("hola",lastOneArray);
    
    if (lastOneArray === undefined) {
      return 1;
    }

    return lastOneArray.id + 1;
  }; */

  const loadSpeciallities = () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "especialidad/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setSpeciallity(data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const updateService = () => {
    var dataSend = {
      nombre: serveName,
      tipo: serveTipo,
      servicios: labs,
      porcentaje: porcentaje,
      id_esp: idEsp,
      formato: formato,
      id_cup: idCup,
      id_servicio: idServe,
      codigo: codigo,
      id_rips_concepto: ripConcept,
      requiere_multicitas: requireMultipleAppointments,
      limite_multicitas:
        requireMultipleAppointments == true ? limitMultipleAppointments : null,
      abreviatura: abreviatture,
      id_caja_contable: selectedLedgerAccount,
      duracion: parseInt(duration),
      ind_hospitalizacion: idHospitalizacion === false ? false: idHospitalizacion, 
      formato_consentimiento:{formato_consentimiento: consentimiento} 
    };

    fetch(process.env.REACT_APP_PUBLIC_URL + "servicio/update", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setOpenAlert(true);
        setModalAlert({
          message: "Servicio Actualizado correctamente",
          color: "success",
          title: "Exitoso!",
        });
        setRequireMultipleAppointments(false);
        setIdHospitalizacion(false);
        setLimitMultipleAppointments(null);
        setConsentimiento([]);
      })
      .catch((error) => {
        setOpenAlert(true);
        setModalAlert({
          message: "Error al actualizar un servicio",
          color: "warning",
          title: "Error!",
        });
        console.error("Error:", error);
      });
  };

  const deleteService = () => {
    var dataSend = { id_servicio: idDelete };

    setIsDelete(false);

    fetch(process.env.REACT_APP_PUBLIC_URL + "servicio/delete", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        console.log(response);
        loadServices();
        return response.json();
      })
      .then((data) => {})
      .catch((error) => {
        console.log(error);
      });
  };

  const validateData = () => {
    let error = false;

    if (serveName === "") error = true;

    if (serveTipo === "") error = true;

    if (porcentaje === "") error = true;

    if (idEsp === "") error = true;

    if (formato === "") error = true;

    if (
      idHospitalizacion === "" ||
      idHospitalizacion === null ||
      idHospitalizacion === undefined
    ) {
      error = true;
    }


    if (error) {
      setOpenAlert(true);
      setModalAlert({
        message:
          "Error al crear un servico, verifica el correcto ingreso de datos",
        color: "warning",
        title: "Error!",
      });
    } else {
      if (isUpdate) {
        updateService();
      } else createService();
    }
  };

  const createService = () => {
    if (
      requireMultipleAppointments == true &&
      limitMultipleAppointments == null
    ) {
      alert("Debe especificar el limite de Multicitas");
      return;
    }

    var dataSend = {
      nombre: serveName,
      tipo: serveTipo,
      servicios: labs,
      porcentaje: porcentaje,
      id_esp: idEsp,
      formato: formato,
      id_cup: idCup != "" && idCup != null && idCup != undefined ? idCup : null,
      codigo: codigo,
      id_rips_concepto: ripConcept,
      requiere_multicitas: requireMultipleAppointments,
      limite_multicitas:
        requireMultipleAppointments == true ? limitMultipleAppointments : null,
      abreviatura: abreviatture,
      id_caja_contable: selectedLedgerAccount,
      duracion: parseInt(duration),
      ind_hospitalizacion:  idHospitalizacion === false ? false: idHospitalizacion , 
      formato_consentimiento:{formato_consentimiento: consentimiento}
    };
    console.log(dataSend);
    fetch(process.env.REACT_APP_PUBLIC_URL + "servicio/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.text();
        }
      })
      .then((data) => {
        setOpenAlert(true);
        setModalAlert({
          message: "Datos agregados correctamente",
          color: "success",
          title: "Exitoso!",
        });
        setRequireMultipleAppointments(false);
        setIdHospitalizacion(false);
        setLimitMultipleAppointments(null);
        setConsentimiento([]);
      })
      .catch((e) => {
        setOpenAlert(true);
        setModalAlert({
          message: e.message,
          color: "warning",
          title: "Error!",
        });
      });
  };

  const getCups = async (cups, name) => {
    setLoading(true);
    let dataSend = {
      cupscod: cups,
      cupsnom: name,
    };

    await fetch(process.env.REACT_APP_PUBLIC_URL + "cups/consultar", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify(dataSend),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.contenido);
        if (data.existe) {
          setCups(data.contenido);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const filterData = (data) => {
    let orderData = [];

    for (let i = 0; i < data.length; i++) {
      orderData[i] = {
        nombretipo:
          data[i].tipo === 1
            ? "Procedimiento"
            : data[i].tipo === 2
            ? "Laboratorio"
            : "Otros",
        tipo: data[i].tipo,
        id_servicio: data[i].id_servicio,
        nombre: data[i].nombre,
        cupscod: data[i].cupscod,
        porcentaje: data[i].porcentaje.toString(),
        formato: data[i].formato,
        id_esp: data[i].id_esp,
        id_cup: data[i].id_cup,
        codigo: data[i].codigo,
        id_rips_concepto: data[i].id_rips_concepto,
        habilitado: data[i].habilitado,
        requiere_multicitas: data[i].requiere_multicitas,
        ind_hospitalizacion: data[i].ind_hospitalizacion,
        limite_multicitas: data[i].limite_multicitas,
        abreviatura: data[i].abreviatura != null ? data[i].abreviatura : "",
        id_caja_contable: data[i].id_caja_contable,
        formato_consentimiento: data[i].formato_consentimiento
      };
    }
    setData(orderData);
    setLoad(false);
  };

  const tableServiciosData = {
    tableHeaderData: [
      {
        Header: "TIPO",
        accessor: "nombretipo",
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: "CODIGO CUPS",
        accessor: "codigo",
      },
      {
        Header: "SERVICIO / PROCEDIMIENTO",
        accessor: "nombre",
      },
      {
        Header: "ABREVIATURA",
        accessor: "abreviatura",
      },
      {
        Header: "PORCENTAJE/VALOR",
        accessor: "porcentaje",
      },
    ],
    tableRowsData: data,
  };

  const tableData = {
    tableHeaderData: [
      {
        Header: "CODIGO",
        accessor: "cupscod",
        disableGlobalFilter: true,
        width: 65,
      },
      {
        Header: "NOMBRE",
        accessor: "cupsnom",
      },
    ],
    tableRowsData: cups,
  };

  const setServiceValue = (name, id, code) => {
    setServName(name);
    setCupCode(code);
    setIdCup(id);
    setModalCups(false);

    if (code != null && code != undefined && code != "") {
      setCodigo(code);
    }
  };

  const setDataToUpadate = (data) => {
    console.log("miraaa",data);
    setServName(data.nombre);
    //setCupCode(data.codigo);
    setCodigo(data.codigo);
    setIdCup(data.id_cup);
    setFormato(data.formato);
    setPorcentaje(data.porcentaje);
    setIdEsp(data.id_esp);
    setServTipo(data.tipo);
    setIdServ(data.id_servicio);
    setRipConcept(data.id_rips_concepto);
    setSave(true);
    setIsUpdate(true);
    setRequireMultipleAppointments(data.requiere_multicitas);
    setIdHospitalizacion(data.ind_hospitalizacion);
    setLimitMultipleAppointments(data.limite_multicitas);
    setAbreviatture(data.abreviatura);
    setSelectedLedgerAccount(data.id_caja_contable);
    setDuration(data.duracion);
    setConsentimiento(data?.formato_consentimiento?.formato_consentimiento??[])
  };

  const listRipsConcepts = async () => {
    fetch(process.env.REACT_APP_PUBLIC_URL + "rips/listar-conceptos", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        setListRipConcept(data);
      })
      .catch((error) => {
        console.error("Error:", error);
        setListRipConcept([]);
      });
  };

  const getTypesServices = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "servicio-tipo/listar", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("typeServicesData", data);
        setListTypesServices(data);
      })
      .catch((error) => {
        console.error("Error:", error);
        setListTypesServices([]);
      });
  };

  const checkConsentimientoInformado = (id)=>{
    return consentimiento.some((item)=>{
      return item.id === id
    })
  }

  const handleChangeCheckbox = (id, titulo) => {
    let existe = consentimiento.some((item)=>item.id === id)
    
    if(existe){
      const newArray = consentimiento.filter((elem) => elem.id !== id)
      setConsentimiento(newArray)
    }else{
      setConsentimiento([...consentimiento, {id, titulo}])
    }
  };

  return (
    <Card>
      <CardBody>
        <TypesServices
          opened={modalTypesServices}
          closeModal={() => setModalTypesServices(false)}
          Callback={getTypesServices}
          listTypesServices={listTypesServices}
        />

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            className="btn btn-sm"
            color="primary"
            onClick={() => {
              console.log("test changed");
              setModalTypesServices(true);
            }}
          >
            Tipos de Servicio
          </Button>

          <Button
            className="btn btn-sm"
            color="primary"
            onClick={() => {
              setModalCups(true);
              setSave(true);
              setIsUpdate(false);
              setServName("");
              setCodigo("");
              setIdCup("");
              setFormato(null);
              setPorcentaje(0);
              setIdEsp(null);
              setServTipo(null);
              setIdServ("");
              setRipConcept(null);
              setRequireMultipleAppointments("");
              setIdHospitalizacion("");
              setLimitMultipleAppointments(null);
              setAbreviatture("");
              setSelectedLedgerAccount(null);
              setConsentimiento([]);
            }}
          >
            Agregar Servicio
          </Button>
        </div>
        {save ? (
          <form className="material-form">
            <Row className="row-form-custom">
              <Col md={9}>
                <Row className="row-form-custom" style={{ rowGap: 3 }}>
                  <Col md={8}>
                    <TextField
                      id="history-number-standard-required"
                      label="Servicio / Procedimiento"
                      type="text"
                      className="medical-material-form__field"
                      value={serveName}
                      onChange={(event) => {
                        setServName(event.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="Tipo"
                      id="id-simplepro-select"
                      className="medical-material-form__field"
                      select
                      value={serveTipo !== "" ? parseInt(serveTipo) : ""}
                      onChange={(event) => {
                        setServTipo(event.target.value);
                      }}
                    >
                      {listTypesServices.map((typeService) => {
                        return (
                          <MenuItem
                            key={typeService.id_servicio_tipo}
                            value={typeService.id_servicio_tipo}
                          >
                            {typeService.nombre}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="Especialidad"
                      id="id-simplepro-select"
                      className="medical-material-form__field"
                      select
                      value={idEsp}
                      onChange={(event) => {
                        setIdEsp(event.target.value);
                      }}
                    >
                      {speciallity.map((special) => {
                        return (
                          <MenuItem
                            key={special.id_especialidad}
                            value={special.id_especialidad}
                          >
                            {" "}
                            {special.especialidad}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Col>
                  <Col md={4}>
                    <TextField
                      id="history-number-standard-required"
                      label="Porcentaje/valor"
                      type="number"
                      className="medical-material-form__field"
                      value={porcentaje}
                      onChange={(e) => {
                        setPorcentaje(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="Formato"
                      id="id-simplepro-select"
                      className="medical-material-form__field"
                      select
                      value={parseInt(formato)}
                      onChange={(event) => {
                        setFormato(event.target.value);
                      }}
                    >
                      <MenuItem key={1} value={1}>
                        {" "}
                        ECO
                      </MenuItem>
                      <MenuItem key={2} value={2}>
                        {" "}
                        EKG
                      </MenuItem>
                      <MenuItem key={3} value={3}>
                        {" "}
                        STREES{" "}
                      </MenuItem>
                      <MenuItem key={4} value={4}>
                        {" "}
                        PRUEBA DE ESFUERZO{" "}
                      </MenuItem>
                      <MenuItem key={5} value={5}>
                        {" "}
                        LABORATORIO{" "}
                      </MenuItem>
                      <MenuItem key={6} value={6}>
                        {" "}
                        HOLTER{" "}
                      </MenuItem>
                      <MenuItem key={7} value={7}>
                        {" "}
                        MAPA{" "}
                      </MenuItem>
                      <MenuItem key={8} value={8}>
                        {" "}
                        REPORTES{" "}
                      </MenuItem>
                      <MenuItem key={9} value={9}>
                        {" "}
                        NINGUNO{" "}
                      </MenuItem>
                    </TextField>
                  </Col>
                  <Col md={4}>
                    <TextField
                      id="history-number-standard-required"
                      label="Código del Servicio"
                      type="text"
                      className="medical-material-form__field"
                      value={codigo !== null ? codigo : ""}
                      onChange={(event) => {
                        setCodigo(event.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="Concepto de RIP"
                      id="id-select-concepto-rip"
                      className="medical-material-form__field"
                      select
                      value={ripConcept !== null ? ripConcept : ""}
                      onChange={(event) => {
                        setRipConcept(event.target.value);
                      }}
                    >
                      {listRipConcept.map((ripCon) => {
                        return (
                          <MenuItem key={ripCon.id} value={ripCon.id}>
                            {" "}
                            {ripCon.nombre}{" "}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="Abreviatura"
                      id="id-abreviatture"
                      inputProps={{ maxLength: 5 }}
                      className="medical-material-form__field"
                      value={abreviatture}
                      onChange={(event) => {
                        setAbreviatture(event.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="Asignar Cuenta Contable"
                      id="id-select-ledger-account"
                      className="medical-material-form__field"
                      select
                      value={
                        selectedLedgerAccount !== null
                          ? selectedLedgerAccount
                          : ""
                      }
                      onChange={(event) => {
                        setSelectedLedgerAccount(event.target.value);
                      }}
                    >
                      {typeLedgerAccounts.map((account) => {
                        return (
                          <MenuItem
                            key={account.id_caja_contable}
                            value={account.id_caja_contable}
                          >
                            {" "}
                            {account.codigo} - {account.descripcion}{" "}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="Duración | minutos"
                      id="id-duration"
                      type="number"
                      inputProps={{ maxLength: 5 }}
                      className="medical-material-form__field"
                      value={duration}
                      onChange={(event) => {
                        setDuration(event.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="Requiere Multicitas?"
                      id="id-select-multicita-service"
                      className="medical-material-form__field"
                      select
                      value={requireMultipleAppointments}
                      onChange={(event) => {
                        setRequireMultipleAppointments(event.target.value);
                      }}
                    >
                      <MenuItem key={0} value={false}>
                        {" "}
                        NO{" "}
                      </MenuItem>
                      <MenuItem key={1} value={true}>
                        {" "}
                        SI{" "}
                      </MenuItem>
                    </TextField>
                  </Col>
                  <Col md={4}>
                    <TextField
                      label="Requiere Aislamiento?"
                      id="id-select-aislamiento-service"
                      className="medical-material-form__field"
                      select
                      value={idHospitalizacion}
                      onChange={(event) => {
                        setIdHospitalizacion(event.target.value);
                        console.log(event.target.value)
                      }}
                    >
                      <MenuItem key={0} value={false}>
                        {" "}
                        NO{" "}
                      </MenuItem>
                      <MenuItem key={1} value={true}>
                        {" "}
                        SI{" "}
                      </MenuItem>
                    </TextField>
                  </Col>
                  <Col md={4}>
                    {requireMultipleAppointments == true ? (
                      <TextField
                        label="Limite de Multicitas"
                        id="id-select-multicita-service-limit"
                        className="medical-material-form__field"
                        type="number"
                        value={limitMultipleAppointments}
                        onChange={(event) => {
                          setLimitMultipleAppointments(event.target.value);
                        }}
                      />
                    ) : null}
                  </Col>
                </Row>
              </Col>
              <Col md={3}>
                <FormLabel component="legend">
                  Consentimientos informados
                </FormLabel>
                {listConsentimientoInformado?.map((consent) => (
                  <FormControl
                    component="fieldset"
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={checkConsentimientoInformado(consent.id)}
                            onChange={()=>{handleChangeCheckbox(consent.id, consent.titulo)}}
                            name="opciones"
                            value={consentimiento}
                          />
                        }
                        label={consent.titulo}
                      />
                    </FormGroup>
                  </FormControl>
                ))}
              </Col>
            </Row>
            <Row className="row-form-custom">
              <Col md={12}>
                <div className="container-buttons-services">
                  <div>
                    <Button
                      color="primary"
                      className="btn btn-sm"
                      onClick={validateData}
                    >
                      {isUpdate ? "Actualizar" : "Guardar"}
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>

            <ModalMat
              open={modalCups}
              onClose={() => {
                setModalCups(false);
              }}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{ zIndex: 1000 }}
            >
              <div
                className="paperAppointment-flex"
                style={{ width: "100%", margin: 10 }}
              >
                <div>
                  <h4 className="bold-text">Selecione el Servicio</h4>
                </div>
                <div className="form">
                  <div style={{ display: "flex", width: "100%" }}>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        Escriba el Codigo
                      </span>
                      <div className="form__form-group-field">
                        <input
                          name="search-cups"
                          component="input"
                          type="text"
                          placeholder="Codigo"
                          onChange={(e) => {
                            getCups(e.target.value, "");
                          }}
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        Escriba el Nombre
                      </span>
                      <div className="form__form-group-field">
                        <input
                          name="search-diagnostic"
                          type="text"
                          placeholder="descripcion"
                          onChange={(e) => {
                            getCups("", e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {!loading ? (
                  <DataCups
                    title={""}
                    reactTableData={tableData}
                    ReactTableActions={CupsDataActions}
                    config={{
                      withPagination: true,
                      withSearchEngine: false,
                      isSortable: false,
                      watchCustomMenu: false,
                    }}
                    setServName={setServiceValue}
                  />
                ) : (
                  <div style={{ margin: "auto", width: 270, height: 420 }}>
                    <div class="load__icon-wrap">
                      <svg class="load__icon">
                        <path
                          fill="#4ce1b6"
                          d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"
                        />
                      </svg>
                    </div>
                  </div>
                )}
              </div>
            </ModalMat>
          </form>
        ) : null}

        {load ? (
          <div className="text-center">
            <Spinner animation="border" variant="success" />
          </div>
        ) : (
          <ServicesTables
            title={"Servicios / Procedimientos"}
            reactTableData={tableServiciosData}
            ReactTableActions={ReactTableActions}
            config={{
              withPagination: true,
              withSearchEngine: true,
              isSortable: true,
              watchCustomMenu: false,
            }}
            updateData={setDataToUpadate}
            Callback={(data) => {
              /*setIdDelete(data.data.original.id_servicio)
              setIsDelete(true)
              console.log(data.data.original.id_servicio);
              */

              loadServices();
            }}
          />
        )}

        <div style={{ margin: 10 }}>
          {openAlert ? (
            <Modal
              color={modalAlert.color}
              title={modalAlert.title}
              message={modalAlert.message}
              modal={openAlert}
              onOk={loadServices}
              toggle={() => {
                setOpenAlert(!openAlert);
              }}
            />
          ) : null}

          {isDelete ? (
            <Modal
              color={"warning"}
              title={"Seguro"}
              message={"¿Deseas eliminar este servicio?"}
              modal={isDelete}
              onOk={deleteService}
              toggle={() => {
                setIsDelete(!isDelete);
              }}
            />
          ) : null}
        </div>
      </CardBody>
    </Card>
  );
};

export default ServicesForm;
